import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileCsv.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "FileCsvIcon";
const c = o;
export {
  c as FileCsv,
  o as FileCsvIcon
};
